import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get, merge } from 'lodash';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsCommunicationHistoryContactLogWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsCommunicationHistoryContactLogWidgetService } from 'services/memberDetailsCommunicationHistoryContactLogWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsCommunicationHistoryContactLogWidgetService = new MemberDetailsCommunicationHistoryContactLogWidgetService();
 * const result = await memberDetailsCommunicationHistoryContactLogWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsCommunicationHistoryContactLogWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsCommunicationHistoryContactLogWidgetService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                    }
                } ),
            } );

            // handle error
            if( SERVICE_RESPONSE_STATUS.ERROR === get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ) ) {
                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                    data: get( response, 'body.component', {} ),
                };
            }

            // handle success
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: get( response, 'body.component', {} ),
            };
        } catch( response ) {
            return {
                status: SERVICE_RESPONSE_STATUS.ERROR,
                data: {},
            };
        }
    }
}
